import actionTypes from './video.actionTypes';
                  
const initialState = {
  isLoadingConfiguration: false,
  isVideoCreatorLoaded: false,
  isVideoPlayerLoaded: false,
  configuration: undefined,
};


export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_VIDEO_CONFIGURATION_BEGIN: return getVideoConfigurationBegin(state);
    case actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS: return getVideoConfigurationSuccess(state, action);
    case actionTypes.GET_VIDEO_CONFIGURATION_FAILURE: return getVideoConfigurationFailure(state);
    case actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS: return setVideoRecorderLoadSuccess(state);
    case actionTypes.SET_VIDEO_CREATOR_LOAD_FAILURE: return setVideoRecorderLoadFailure(state);
    case actionTypes.SET_VIDEO_PLAYER_LOAD_SUCCESS: return setVideoPlayerLoadSuccess(state);
    case actionTypes.SET_VIDEO_PLAYER_LOAD_FAILURE: return setVideoPlayerLoadFailure(state);
      
    default:
      return state;
  }
}


const getVideoConfigurationBegin = (state) => {
  return {
    ...state,
    isLoadingConfiguration: true,
  };
};

const getVideoConfigurationSuccess = (state, action) => {
  let configuration = action.data.configuration;  
  return {
    ...state,
    isLoadingConfiguration: false,
    configuration: configuration,
  };
};

const getVideoConfigurationFailure = state => {
  return {
    ...state,
    isLoadingConfiguration: false
  };
};

const setVideoRecorderLoadSuccess = state => {
  return {
    ...state,
    isVideoCreatorLoaded: true
  };
};

const setVideoRecorderLoadFailure = state => {
  return {
    ...state,
    isVideoCreatorLoaded: false
  };
};

const setVideoPlayerLoadSuccess = state => {
  return {
    ...state,
    isVideoPlayerLoaded: true
  };
};

const setVideoPlayerLoadFailure = state => {
  return {
    ...state,
    isVideoPlayerLoaded: false
  };
};

